<div class="envelope-container"
     [@pulse]="danceState ? 'active' : 'inactive'"
     (@pulse.done)="restartAnimation()"
     (click)="openOffer()">

  <div class="envelope-wrapper">
    <img src="../../../../assets/Images/offerIcon.png"
         alt="Offer Envelope"
         class="envelope" />
    <!--<p class="envelope-text">You have an offer!</p>-->
    <p class="envelope-text">Tap to see your offer!</p>
  </div>
</div>
